<template>
  <div class="" >

    <!-- HEAD -->

    <div class="head row p-0 g-0">
      <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0"  data-aos="fade-right" data-aos-duration="500">
        <img :src="`${publicPath}img/03datos.jpg`" class="img-responsive">
      </div>
      <div class="headRight py-3 py-md-0 py-lg-5" data-aos="fade-right" data-aos-delay="400" data-aos-duration="200" data-aos-id="super-duper">
        <h1 class="my-3 my-lg-0 my-xl-3 my-xxl-5">03</h1>
        <h2 class="my-3 my-lg-0 my-xl-3">{{ $t('informe.informe_financero') }}</h2>
        <p class="text-end pt-2 pt-md-3 pt-xl-3">{{ $t('informe.recuperacion') }}</p>
      </div>
    </div>

    <!-- end HEAD -->

    <div class="contingut bg-white row g-0">
      <div class="col-12 col-lg-10 m-auto mt-5 py-5">
        <h2 class="mb-3" data-aos="fade" data-aos-duration="1500">{{ $t('informe.datos') }}</h2>
        <p class="text-turquesa px-1 mx-0 px-md-5 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('informe.el_ano') }}</p>
      </div>
    </div>

    <div class="contingut bg-white row g-0 ">
      <div class="col-12 mb-5 py-5 border-bottom position-relative  bg-darkBlue">
        <div class="row align-items-top my-5">
          <div class="col-10 m-auto">
            <div class="row g-0" data-aos="fade-in" data-aos-duration="0" data-aos-id="start-counter-informe">
              <div class="col-12 col-md-6 col-lg-3">
                <h4 class="text-turquesa"><strong>{{ $t('informe.cifra') }}</strong></h4>
                <p class="numbers text-white">
                  <AnimatedNumber
                  ref='counter_cifra'
                  :startAmount='0'
                  :endAmount='2053'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  decimalSeparator=','
                  :decimals='0'
                  :autoinit='true'
                  />
                </p>
                <h5 class="numbersPeu text-white"><strong>{{ $t('informe.millones') }}</strong></h5>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <h4 class="text-turquesa"><strong>{{ $t('informe.ebitda') }}</strong></h4>
                <p class="numbers text-white">
                  <AnimatedNumber
                  ref='counter_millones'
                  :startAmount='0'
                  :endAmount='401'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  decimalSeparator='.'
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
                  />

                </p>
                <h5 class="numbersPeu text-white"><strong>{{ $t('informe.millones') }}</strong></h5>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <h4 class="text-turquesa"><strong>{{ $t('informe.resultado') }}</strong></h4>
                <p class="numbers text-white">
                  <AnimatedNumber
                  ref='counter_resultado'
                  :startAmount='0'
                  :endAmount='179'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  decimalSeparator='.'
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
                  />
                </p>
                <h5 class="numbersPeu text-white"><strong>{{ $t('informe.millones') }}</strong></h5>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <h4 class="text-turquesa"><strong>{{ $t('informe.inversiones_corrientes') }}</strong></h4>
                <p class="numbers text-white">
                  <AnimatedNumber
                  ref='counter_inversiones'
                  :startAmount='0'
                  :endAmount='124'
                  :duration='3'
                  prefix=''
                  suffix=''
                  :separator=separator
                  decimalSeparator='.'
                  :decimals='0'
                  :autoinit='true'
                  @finished='counterFinished'
                  /></p>
                <h5 class="numbersPeu text-white"><strong>{{ $t('informe.millones') }}</strong></h5>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="contingut bg-white row g-0 pt-5">
      <hr>
      <div class="col-12 col-lg-10 m-auto pt-5">
        <h2 class="mb-3" data-aos="fade" data-aos-duration="1500">{{ $t('informe.cifra_negocios') }}</h2>
        <p class="text-turquesa px-1 mx-0 px-md-5 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('informe.importe_neto') }}</p>
      </div>
    </div>

    <div class="contingut bg-white row g-0 ">
      <div class="col-12 pb-5 border-bottom position-relative">
        <div class="blocCollapseR">
          <a class="btnCollapseIn btnFosc" data-bs-toggle="collapse" href="#collapse02" role="button" aria-expanded="false" aria-controls="collapse02"><i class="fa-solid fa-plus"></i></a>
          <div class="collapse collapseR" id="collapse02">
            <div class="card card-body txtCollapse">
              <div class="row align-items-center">
                <div class="col-12">
                  <div class="zonaCollapse">
                    <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse02" role="button" aria-expanded="false" aria-controls="collapse02"><i class="fa-solid fa-xmark"></i></a>
                  </div>
                </div>
                <div class="col-12 my-3 my-xxl-5 py-5 px-0 px-sm-0 px-md-5 text-white">
                  <p>{{ $t('informe.c1') }}</p>
                  <p>{{ $t('informe.c2') }}</p>
                  <p>{{ $t('informe.c3') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-top my-5">
          <div class="col-12 col-lg-11 m-auto">
            <intersection-observer
              sentinal-name="sentinal-bars-chart"
              @on-intersection-element="toogleBarsChart"
            >
            <animated-bars v-if="BarsIsOnViewport" :height="60" :style="'max-width: 1150px;margin: 0 auto;'" :key="mybarchart" />
            </intersection-observer>
            <p align="right" class="llegenda">{{ $t('resumen.en-millones-eur') }}</p>
          </div>
        </div>

      </div>
    </div>


    <div class="contingut bg-white row g-0">
      <div class="col-12 col-lg-10 m-auto pt-5">
        <h2 class="mb-3" data-aos="fade" data-aos-duration="1500">{{ $t('informe.resultados') }}</h2>
        <p class="text-turquesa px-1 mx-0 px-md-5 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('informe.resultados_txt') }}</p>
      </div>
    </div>

    <div class="contingut bg-white row g-0 ">
      <div class="col-12 pb-5 border-bottom position-relative ">
        <div class="blocCollapseR">
          <a class="btnCollapseIn btnFosc" data-bs-toggle="collapse" href="#collapse03" role="button" aria-expanded="false" aria-controls="collapse03"><i class="fa-solid fa-plus"></i></a>
          <div class="collapse collapseR" id="collapse03">
            <div class="card card-body txtCollapse">
              <div class="row align-items-center">
                <div class="col-12">
                  <div class="zonaCollapse">
                    <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse03" role="button" aria-expanded="false" aria-controls="collapse03"><i class="fa-solid fa-xmark"></i></a>
                  </div>
                </div>
                <div class="col-12 my-3 my-xxl-5 py-5 px-0 px-sm-0 px-md-5 text-white">
                  <p>{{ $t('informe.r1') }}</p>
                  <p>{{ $t('informe.r2') }}</p>
                  <p>{{ $t('informe.r3') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-top my-5">
          <div class="col-12 col-lg-11 m-auto">
            <intersection-observer
              sentinal-name="sentinal-line-chart"
              @on-intersection-element="toogleLinesChart"
            >
            <animated-lines v-if="LinesIsOnViewport" :key="mylinechart" :height="70" :style="'max-width: 1150px;margin: 0 auto;'" />
            </intersection-observer>
          </div>
            <p class="llegenda mt-5">{{ $t('informe.porcentaje_ebitda') }} <img :src="`${publicPath}img/llegenda01.gif`" class="img-responsive ms-5"> {{ $t('informe.ebitda') }} <img :src="`${publicPath}img/llegenda02.gif`" class="img-responsive ms-5"> {{ $t('informe.beneficio_neto') }}</p>
        </div>

      </div>
    </div>


    <div class="contingut bg-white row g-0">
      <div class="col-12 col-lg-10 m-auto py-5">
        <h2 class="mb-3" data-aos="fade" data-aos-duration="1500">{{ $t('informe.inversiones_title') }}</h2>
        <p class="text-turquesa px-1 mx-0 px-md-5 mx-lg-5" data-aos="fade-left" data-aos-duration="1000">{{ $t('informe.inversiones_txt') }}</p>
      </div>
    </div>

    <div class="contingut bg-white row g-0 ">
      <div class="col-12 pb-5 position-relative">
        <div class="blocCollapseR">
          <a class="btnCollapseIn btnFosc" data-bs-toggle="collapse" href="#collapse04" role="button" aria-expanded="false" aria-controls="collapse04"><i class="fa-solid fa-plus"></i></a>
          <div class="collapse collapseR" id="collapse04">
            <div class="card card-body txtCollapse">
              <div class="row align-items-center">
                <div class="col-12">
                  <div class="zonaCollapse">
                    <a class="btnCollapseIn btnTancar" data-bs-toggle="collapse" href="#collapse04" role="button" aria-expanded="false" aria-controls="collapse04"><i class="fa-solid fa-xmark"></i></a>
                  </div>
                </div>
                <div class="col-12 my-3 my-xxl-5 py-3 px-0 px-sm-0 px-md-5 text-white">
                  <h4 class="text-white">{{ $t('informe.inversiones') }}</h4>
                  <p>{{ $t('informe.i1') }}
                  <br>{{ $t('informe.i2') }}</p>
                  <h4 class="text-white">{{ $t('informe.estructura_financera') }}</h4>
                  <p>{{ $t('informe.i3') }}
                  <br>{{ $t('informe.i4') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-top my-5">
          <div class="col-12 col-lg-10 m-0 p-0 pb-5 m-auto">
            <div class="table-responsive">
            <table class="table table-hover tableRG">
              <thead>
              <tr class="topTable">
                <th scope="col"></th>
                <th scope="col">2016</th>
                <th scope="col">2017</th>
                <th scope="col">2018</th>
                <th scope="col">2019</th>
                <th scope="col">2020</th>
                <th scope="col">2021</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="this.$i18n.locale=='es'">
                <th scope="row" class="align-middle colTable text-start">{{ $t('informe.total_patrimonio') }}</th>
                <td class="px-0 px-lg-3">1.353</td>
                <td class="px-0 px-lg-3">1.276</td>
                <td class="px-0 px-lg-3">1.305</td>
                <td class="px-0 px-lg-3">1.402</td>
                <td class="px-0 px-lg-3">1.289</td>
                <td class="px-0 px-lg-3">1.552</td>
              </tr>
              <tr v-else >
                <th scope="row" class="align-middle colTable text-start">{{ $t('informe.total_patrimonio') }}</th>
                <td class="px-0 px-lg-3">1,353</td>
                <td class="px-0 px-lg-3">1,276</td>
                <td class="px-0 px-lg-3">1,305</td>
                <td class="px-0 px-lg-3">1,402</td>
                <td class="px-0 px-lg-3">1,289</td>
                <td class="px-0 px-lg-3">1,552</td>
              </tr>
              <tr>
                <th nowrap="nowrap" scope="row" class="align-middle colTable text-start">{{ $t('informe.inversiones_corrientes') }}</th>
                <td>145</td>
                <td>116</td>
                <td>145</td>
                <td>154</td>
                <td>106</td>
                <td>124</td>
              </tr>
              <tr>
                <th scope="row" class="align-middle colTable text-start">{{ $t('informe.situacion_financera_neta') }}</th>
                <td>(322)</td>
                <td>(323)</td>
                <td>(378)</td>
                <td>(365)</td>
                <td>(194)</td>
                <td>(117)</td>
              </tr>
              </tbody>
            </table>
            </div>
            <p align="right" class="llegenda">{{ $t('resumen.en-millones-eur') }}</p>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import AnimatedBars from '@/components/ChartBars.vue'
  import AnimatedLines from '@/components/ChartLine.vue'
  import AnimatedNumber from 'vue3-autocounter'
  import IntersectionObserver from '@/components/IntersectionObserver.vue'

  export default {
    components: {
      AnimatedBars,
      AnimatedLines,
      AnimatedNumber,
      IntersectionObserver
    },
    data() {
      return {
        publicPath: process.env.BASE_URL,
        BarsIsOnViewport: false,
        LinesIsOnViewport: false,
        separator: '.'
      }
    },
    mounted() {
      document.addEventListener('aos:in:start-counter-informe', this.startCounter);
      if(this.$i18n.locale=="es"){
          this.separator = '.';
      } else {
          this.separator = ',';
      }
    },
    methods: {
      startCounter() {
        if (this.$refs.counter_cifra != null) {
          this.$refs.counter_cifra.start();
        }
        if (this.$refs.counter_millones != null) {
          this.$refs.counter_millones.start();
        }
        if (this.$refs.counter_resultado != null) {
          this.$refs.counter_resultado.start();
        }
        if (this.$refs.counter_inversiones != null) {
          this.$refs.counter_inversiones.start();
        }
      },
      toogleLinesChart(visible) {
        this.LinesIsOnViewport = visible;
      },
      toogleBarsChart(visible) {
        this.BarsIsOnViewport = visible;
      }
    }
  }
</script>
